export const cpf = strCPF => {
    let Soma;
    let Resto;

    Soma = 0;

    if (strCPF.length < 1) {
        return { value: false,
            mess: 'O campo CPF é obrigatório' };
    }

    if (strCPF == '00000000000') {return { value: false,
        mess: 'O campo CPF é obrigatório' };}

    strCPF = strCPF.replace(/\D/g, '');

    for (let i = 1; i <= 9; i++) {Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);}

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) {Resto = 0;}

    if (Resto != parseInt(strCPF.substring(9, 10))) {return { value: false,
        mess: 'Erro! CPF inválido' };}

    Soma = 0;

    for (let i = 1;  i <= 10; i++) {Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);}

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) {Resto = 0;}

    if (Resto != parseInt(strCPF.substring(10, 11))) {return { value: false,
        mess: 'Erro! CPF inválido' };}

    return true;
};

export const validarCpfSemMascara = cpf => {
    cpf = cpf.replace(/[^\d]+/g, '');

    if (cpf == '') {return false;}

    // Elimina CPFs invalidos conhecidos    
    if (cpf.length != 11 ||
        cpf == '00000000000' ||
        cpf == '11111111111' ||
        cpf == '22222222222' ||
        cpf == '33333333333' ||
        cpf == '44444444444' ||
        cpf == '55555555555' ||
        cpf == '66666666666' ||
        cpf == '77777777777' ||
        cpf == '88888888888' ||
        cpf == '99999999999')
    {return false;}

    // Valida 1o digito    
    let add = 0;

    for (let i = 0; i < 9; i++)
    {add += parseInt(cpf.charAt(i)) * (10 - i);}

    let rev1 = 11 - (add % 11);

    if (rev1 == 10 || rev1 == 11)
    {rev1 = 0;}

    if (rev1 != parseInt(cpf.charAt(9)))
    {return false;}

    // Valida 2o digito    
    add = 0;

    for (let i = 0; i < 10; i++)
    {add += parseInt(cpf.charAt(i)) * (11 - i);}

    let rev = 11 - (add % 11);

    if (rev == 10 || rev == 11)
    {rev = 0;}

    if (rev != parseInt(cpf.charAt(10)))
    {return false;}

    return true;
};

export const cpfLogin = strCPF => {
    let Soma;
    let Resto;

    Soma = 0;

    if (strCPF.length < 1) {
        return { value: false,
            mess: 'O campo CPF é obrigatório' };
    }

    if (strCPF.length !== 11) {
        return { value: false,
            mess: 'Usuário inválido, insira seu E-mail ou CPF' };
    }

    if (strCPF != Number(strCPF)) {
        return { value: false,
            mess: 'Usuário inválido, insira seu E-mail ou CPF' };
    }

    if (strCPF == '00000000000') {return { value: false,
        mess: 'O campo CPF é obrigatório' };}

    strCPF = strCPF.replace(/\D/g, '');

    for (let i = 1; i <= 9; i++) {Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);}

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) {Resto = 0;}

    if (Resto != parseInt(strCPF.substring(9, 10))) {return { value: false,
        mess: 'Erro! CPF inválido' };}

    Soma = 0;

    for (let i = 1; i <= 10; i++) {Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);}

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) {Resto = 0;}

    if (Resto != parseInt(strCPF.substring(10, 11))) {return { value: false,
        mess: 'Erro! CPF inválido' };}

    return true;
};